export const SETTLEMENT_EXPORTS_QUERY_KEY = 'settlement_exports'

// apiClient appends the trailing slash these paths need. Without it Django answers 301, and fetch
// follows a 301 as a GET without the body, so the create silently turns into a list request.
export const SETTLEMENT_EXPORTS_ENDPOINT = 'settlement_exports'
export const SETTLEMENT_EXPORTS_CREATE_ENDPOINT = 'settlement_exports/create'
export const settlementExportDownloadEndpoint = (id: number): string => `settlement_exports/${id}/download`

/**
 * A `SystemFeatureFlag` in aurora-django, ticked per system in the System admin. The feature is
 * hidden on every system that does not have it.
 */
export const SETTLEMENT_EXPORT_SYSTEM_FEATURE_FLAG = 'use_settlement_export'

/** Frozen wire name, sent on the shared `aurora-django-system-{id}` channel. */
export const SETTLEMENT_EXPORT_UPDATED_EVENT = 'settlement_export_updated'

/** The backend builds and labels every export in Stockholm time, whatever the browser's zone. */
export const SETTLEMENT_TIME_ZONE = 'Europe/Stockholm'
export const SETTLEMENT_EXPORT_MAX_PERIOD_DAYS = 32
export const SETTLEMENT_EXPORT_LIST_MAX_WINDOW_DAYS = 30
